var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLegalPaperIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.839,
    height: 19.075,
    viewBox: "0 0 19.839 19.075",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#959595;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -7.627)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 7.627)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M287.974,61.631h0v0Z",
    transform: "translate(-273.561 -58.924)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.132,7.627H5.12a2.711,2.711,0,0,0-2.707,2.707V21.3a2.707,2.707,0,0,0,.3,5.4H12.5A2.711,2.711,0,0,0,15.21,24V13.04h1.922a2.707,2.707,0,1,0,0-5.413ZM10.585,25.9H2.717a1.908,1.908,0,0,1,0-3.816h7.868A2.7,2.7,0,0,0,10.585,25.9Zm3.828-15.568V24a1.906,1.906,0,1,1-1.906-1.906.4.4,0,1,0,0-.8H3.23V10.334A1.91,1.91,0,0,1,5.12,8.428H15.2A2.7,2.7,0,0,0,14.413,10.334ZM17.532,12.2v0l-2.318,0V10.334A1.906,1.906,0,1,1,17.532,12.2Z",
    transform: "translate(0 -7.627)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.424 11.599)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M114.632,86.987h-5.858a.4.4,0,0,0,0,.8h5.858a.4.4,0,1,0,0-.8Z",
    transform: "translate(-108.374 -86.987)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.424 14.458)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M114.632,144.107h-5.858a.4.4,0,0,0,0,.8h5.858a.4.4,0,1,0,0-.8Z",
    transform: "translate(-108.374 -144.107)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.424 17.317)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M114.632,201.227h-5.858a.4.4,0,1,0,0,.8h5.858a.4.4,0,1,0,0-.8Z",
    transform: "translate(-108.374 -201.227)"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLegalPaperIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/legal-paper-icon.9693241b01bbd45f292d897a12497b2d.svg";